import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonImg } from '@ionic/react';
import ReactDOM from 'react-dom';

import { Auth_Zasava_Context } from '../../../storeState/Auth_Zasava_Context';
import { UploadTemplateModal } from './Modal_UploadTemplate';


export function ViewUploadedTemplatesModal(props) {

    let zasava_context = useContext(Auth_Zasava_Context);


    let [acctID, setAcctID ] = useState(zasava_context.acctID);
    let [schema, setSchemaName] = useState(zasava_context.schema);
    let [sessionID, setSessionID ] = useState(zasava_context.sessionID);
    let [baseURL, setBaseURL ] = useState(zasava_context.baseURL);

    let [merchantAccountID, setMerchantAccountID] = useState(props.data.data_merchantID);
    let [merchantSchema, setMerchantSchema] = useState(null);
    let [templateID, setTemplateID] = useState(null);
    let [zsavaTemplateFile, setZsavaTemplateFile] = useState();

    let [viewMerchantTemplatesList, setViewMerchantTemplatesList ] = useState([]);
    let [viewUploadTemplateModal, setUploadTemplateModal] = useState(false);


    useEffect(() => {

        //alert('In ViewUploadedTemplatesModal USEEFFECT');
        //alert(props.data.data_merchantID);

        if(props.openModal == true)
        {

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                //body: JSON.stringify({formData})
                body: JSON.stringify({
                    Tracker: '9006',
                    xMerchantAccountID: props.data.data_merchantID,
                    sessionID: sessionID,
                })
            }
    

            
            fetch(baseURL+'/admin_zsava_indexApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');

                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    //alert('Inside ViewAvailableRooms FETCH');
                    //alert(rows.length);
                    //alert(cols.length);
                    //alert(viewInventoryAvailableRooms);



                    setViewMerchantTemplatesList((prevViewMerchantList) => {
                        return prevViewMerchantList.concat({
                            templateID: cols[0],
                            templateFile_original: cols[1],
                            templateFile_postscript: cols[2],
                            merchantSchemaName: cols[3],
                        })
                    });
                } 
            })
        }

    }, [props.openModal])

    function uploadPS_To_MerchantSite(event)
    {

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: '9006_A',
                xMerchantAccountID: event[0],
                xImageID: event[1],
                xMerchantSchemaName: event[2],
                sessionID: sessionID
            })
        }

        
        fetch(baseURL+'/admin_zsava_indexApp', requestOptions)
        .then(res => res.text())
        .then(res => {

                alert(res);
        })
    }


    function uploadTemplateHandler(event) {  

        setUploadTemplateModal(event[0]);
        setTemplateID(event[2]);
        setMerchantSchema(event[3]);
    }

    function closeModalHandler(event) {

        //alert('Inside closeModalHandler');
        setViewMerchantTemplatesList([]);
        props.closeModal(event);
    }

    return (

        <React.Fragment>            
            {props.openModal == true ?
            (
                <div>
                {/* {ReactDOM.createPortal(<Backdrop />, document.getElementById('backdrop-root'))} */}

                <IonModal isOpen={ props.openModal }>
                    <IonText> Rooms Available </IonText>
                    <IonGrid class='gridText'>
                        <IonRow class='gridResultHeaders'>
                                <IonCol >Template ID</IonCol>
                                <IonCol >Original File</IonCol>
                                <IonCol >Zsava File</IonCol>
                                <IonCol >Company Schema</IonCol>
                                <IonCol >Action</IonCol>
                        </IonRow>
                        {viewMerchantTemplatesList.map((detailData) =>   {
                            return (
                                <IonRow class='gridResultBody' key={detailData.templateID}>
                                    <IonCol >{detailData.templateID}</IonCol>
                                    <IonCol >
                                        <IonImg src={detailData.templateFile_original}></IonImg>
                                    </IonCol>
                                    <IonCol >
                                        <IonImg src={detailData.templateFile_postscript}></IonImg>
                                    </IonCol>
                                    <IonCol >{detailData.merchantSchemaName}</IonCol>
                                    <IonCol >
                                        <IonButton class='gridResultColumnButton' onClick={() => uploadTemplateHandler([true, props.data.data_merchantID, detailData.templateID, detailData.merchantSchemaName])}> Upload Z Template Internal </IonButton>
                                        <IonButton class='gridResultColumnButton' onClick={() => uploadPS_To_MerchantSite([props.data.data_merchantID, detailData.templateID, detailData.merchantSchemaName])}> Upload Z PS to Customer Site </IonButton>
                                    </IonCol>
                                </IonRow>
                            )
                        }
                        )}
                    </IonGrid>

                    <UploadTemplateModal openModal={ viewUploadTemplateModal } closeModal={() => setUploadTemplateModal(false)} data={{
                        data_merchantID: props.data.data_merchantID, 
                        data_templateNumber: templateID, 
                        data_merchantSchemaName: merchantSchema
                        }}></UploadTemplateModal>

                    <IonButton onClick={() => closeModalHandler(false)}> Close </IonButton>
                </IonModal>            
            </div>
            ) : null }
        </React.Fragment>
    )
}